"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayerSettings = void 0;
var reUtils_1 = require("./reUtils");
/**
 * Stores settings for individual layers.
 */
var LayerSettings = /** @class */ (function () {
    /**
     * Creates a new instance
     * @param options An object that implements ILayerSettings.
     */
    function LayerSettings(options) {
        if (options) {
            this.visible = options.visible;
            this.visibleLayers = options.visibleLayers;
        }
    }
    /**
     * Converts a string from a URLSearchParams value into a LayerSettings.
     * @param str a value from a URLSearchParams.
     */
    LayerSettings.parse = function (str) {
        var trueRe = (0, reUtils_1.makeBooleanRe)(true, false);
        var falseRe = (0, reUtils_1.makeBooleanRe)(false, false);
        var sublayersRe = /\-?\d+/g; // matches all instances of integers in a string.
        var visible = trueRe.test(str)
            ? true
            : falseRe.test(str)
                ? false
                : undefined;
        var visibleLayers;
        var sublayersMatch = str.match(sublayersRe);
        if (sublayersMatch) {
            visibleLayers = sublayersMatch.map(function (s) { return parseInt(s, 10); });
        }
        if (visible === undefined && visibleLayers) {
            visible = true;
        }
        if (visible === null) {
            return null;
        }
        var layerSettings = new LayerSettings({
            visible: visible,
            visibleLayers: visibleLayers
        });
        return layerSettings;
    };
    /**
     * Applies the settings to an operational layer.
     * @param operationalLayer An operational layer from a layer list.
     */
    LayerSettings.prototype.apply = function (operationalLayer) {
        var layer = operationalLayer.layer;
        if (!layer) {
            return;
        }
        // TypeScript cast to more specific type to allow check for
        // suspend and resume functions.
        var refreshAbleLayer = layer;
        // Suspend drawing operations until all layer properties are set.
        if (refreshAbleLayer.suspend) {
            refreshAbleLayer.suspend();
        }
        if (this.visible != null) {
            operationalLayer.visibility = this.visible;
            layer.setVisibility(this.visible);
        }
        if (operationalLayer.showSubLayers !== false &&
            this.visibleLayers &&
            refreshAbleLayer.setVisibleLayers) {
            refreshAbleLayer.setVisibleLayers(this.visibleLayers);
        }
        // Resume layer drawing.
        if (refreshAbleLayer.resume) {
            refreshAbleLayer.resume();
        }
    };
    /**
     * Converts to string for use with URLSearchParams
     */
    LayerSettings.prototype.toString = function () {
        var checked = "✓";
        var unchecked = "⍻";
        var checkedState = this.visible == null ? "" : this.visible ? checked : unchecked;
        // const visibleLayers = this.visibleLayers
        //   ? this.visibleLayers.join(" ")
        //   : "";
        // return visibleLayers ? `${checkedState} ${visibleLayers}`
        if (this.visibleLayers) {
            return [checkedState]
                .concat(this.visibleLayers.map(function (n) { return n.toString(10); }))
                .join(" ");
        }
        return checkedState;
    };
    return LayerSettings;
}());
exports.LayerSettings = LayerSettings;
